<template>
  <v-dialog v-model="dialog" max-width="860px">
    <v-card class="overflow-x-hidden newsletter">
      <form @submit.prevent="onSubmit">
        <v-row style="min-height: 500px">
          <v-col cols="6" class="newsletter-left">
            <p class="newsletter-title">
              {{ mess["widget_newsletter_text_row_1"] }}
            </p>
            <div class="newsletter-left__checkboxes">
              <v-checkbox
                v-for="item in categories"
                :key="item.id"
                v-model="form.categories"
                :label="item.title"
                :value="item.id"
                :ripple="false"
                class="newsletter-checkbox"
                color="#ffffff"
                hide-details
                off-icon="mdi-checkbox-blank"
              ></v-checkbox>
              <p v-if="!isSelected" class="newsletter-checkbox-message">
                {{ mess["widget_newsletter_form_required_category"] }}
              </p>
            </div>
            <p class="newsletter-left__note">
              {{ mess["widget_newsletter_text_row_2"] }}
            </p>
          </v-col>
          <v-col cols="6" class="newsletter-right">
            <p class="newsletter-description">
              {{ mess["widget_newsletter_text_row_3"] }}
            </p>
            <p class="newsletter-note">
              {{ mess["widget_newsletter_text_row_4"] }}
            </p>
            <v-text-field
              disabled
              :value="email"
              :label="mess['widget_newsletter_form_label_email']"
            ></v-text-field>
            <v-text-field
              disabled
              :value="name"
              :label="mess['widget_newsletter_form_label_name']"
            ></v-text-field>
            <v-card-actions style="padding: 24px" class="d-flex justify-center">
              <v-btn color="primary" depressed dark type="submit"
                >{{ mess["widget_newsletter_form_button_submit"] }}
              </v-btn>
            </v-card-actions>
            <v-btn absolute top right text icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from "@/mixins/Form";
import { newsletterService } from "@/services/newsletter-service";
import notifications from "@/models/notificationTemplates";

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "NewsletterDialog",
  mixins: [Form],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: () => []
    },
    email: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      dialog: false,
      isSelected: true,
      form: {
        categories: [],
        email: this.email,
        name: this.name
      }
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        this.isSelected = !!this.form.categories?.length;

        if (valid && this.form.categories?.length) {
          newsletterService
            .submit(this.createFormData())
            .then(() => {
              this.$emit("submit", notifications.success.newsletter);
              this.dialog = false;
              this.clearForm(this.form, this.$validator, {
                email: this.email,
                name: this.name
              });
            })
            .catch(() => {
              this.$emit("submit", notifications.error.base);
            });
        }
      });
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    getForm() {
      return this.form;
    },
    setFormProp(prop, value) {
      this.form[prop] = value;
    }
  },
  watch: {
    "form.categories"(val) {
      this.isSelected = !!val?.length;
    },
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  mounted() {
    this.$validator.localize("ru", this.dictionary);
  },
  created() {
    const { openDialog, closeDialog, getForm, setFormProp } = this;

    function createWidget() {
      return {
        openDialog,
        closeDialog,
        getForm,
        setFormProp
      };
    }

    window.__WIDGET_NEWSLETTER__ = createWidget();
  }
};
</script>

<style lang="scss">
@import "NewsletterDialog";
</style>
